var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.$route.meta.layout)?_c('HeaderBlock'):_vm._e(),_c('router-view'),_c('img',{staticClass:"main-FAQ",attrs:{"src":require("@/assets/png/FAQ.png"),"alt":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }